import Constant from '../../apis/constants';
import {images} from '../../assets/images';

export function baseUrl(path) {
  // console.log('aaaa',Constant.image + path);
  if (path && path !== null && path !== '') return Constant.image + path;
  else return images.user1;
}

export function renderImage(image, size = 'small') {
  if (typeof image === 'string') {
    return image ? baseUrl(image) : images.user1;
  } else if (size == 'large') {
    return image && image.large && image.large !== ``
      ? baseUrl(image.large)
      : image && image.original && image.original !== ``
      ? baseUrl(image.original)
      : null;
  } else if (size === 'medium') {
    return image && image.medium && image.medium !== ``
      ? baseUrl(image.medium)
      : image && image.original && image.original !== ``
      ? baseUrl(image.original)
      : null;
  } else {
    return image && image.small && image.small !== ``
      ? baseUrl(image.small)
      : image && image.original && image.original !== ``
      ? baseUrl(image.original)
      : images.listing;
  }
}
